/** @file Export dialog options: common fields, animation and skin pick lists, sprite-sheet fields. */
import { CheckList } from '../../ui-kit/CheckList';
import type { ExportChoices } from './exportChoices';
import { ExportFields, type FieldsProps } from './ExportFields';
import { formSetter } from './formSetter';
import { SpriteFields } from './SpriteFields';

/** Empty pick lists export everything (the hint says so). */
export function ExportOptionsForm({ t, form, onChange, choices }: FieldsProps & { choices: ExportChoices }) {
  const set = formSetter(form, onChange);
  return (
    <div className="export-form">
      <ExportFields t={t} form={form} onChange={onChange} />
      <p className="shell-hint">{t('exportDialog.allHint')}</p>
      <CheckList legend={t('exportDialog.animations')} options={choices.animations} picked={form.animations} onChange={(next) => { set('animations', next); }} />
      <CheckList legend={t('exportDialog.skins')} options={choices.skins} picked={form.skins} onChange={(next) => { set('skins', next); }} />
      {form.target === 'spritesheet' ? <SpriteFields t={t} form={form} onChange={onChange} directions={choices.directions} /> : null}
    </div>
  );
}
